import styled from 'styled-components';

export const StyledCongratulationsFullScreen = styled.section`
  background: ${({ theme }) => theme.colors.background.dark};
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: 1000;
  overflow-y: auto;
`;

export const StyledContainer = styled.div`
  max-width: 1076px;
  height: 100vh;
  display: grid;
  grid-template-rows: 1fr auto;
  margin: 0 auto;
  padding: 0 2rem;
`;

export const StyledTitle = styled.h1`
  color: ${({ theme }) => theme.colors.text.main};
  font-size: 3.2rem;
  text-align: center;
  margin-bottom: 1.8rem;
  line-height: 3.67rem;
`;

export const StyledSubTitle = styled.p`
  color: ${({ theme }) => theme.colors.paragraph};
  text-align: center;
  margin-bottom: 1.8rem;
`;

export const StyledContentWrapper = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin: 3rem 2rem 0;
  gap: 4.6rem;

  &[data-content='social-sharing'] {
    margin: 0 8rem;
  }

  &[data-content='next-room'] {
    max-width: 70rem;
    margin: 0 auto;
  }

  &[data-content='badge-sharing'] {
    margin: 2rem 8rem;
  }
`;

export const StyledFooter = styled.footer`
  border-top: 1px solid ${({ theme }) => theme.colors.border.main};
  padding: 2.4rem 0 8rem;
  display: flex;
  justify-content: space-between;
`;

export const StyledButtonWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 1.6rem;
`;
